import { SOCIAL_TYPE, SOCIAL_TYPE_TEXT } from '@shootsta/common-domain-data';

export const getSocialAuthButtonPropsByType = (type) => {
  let props;

  switch (type) {
    case SOCIAL_TYPE.LINKED_IN:
      props = {
        type: 'TERTIARY',
        prefix: 'linkedin2'
      };
      break;
    case SOCIAL_TYPE.MICROSOFT:
      props = {
        type: 'TERTIARY',
        prefix: 'microsoftcolor'
      };
      break;
    case SOCIAL_TYPE.APPLE:
      props = {
        type: 'TERTIARY',
        prefix: 'apple'
      };
      break;
    case SOCIAL_TYPE.GOOGLE:
    default:
      props = {
        type: 'TERTIARY',
        prefix: 'google'
      };
      break;
  }

  return {
    ...props,
    children: `Continue with ${SOCIAL_TYPE_TEXT[type]}`
  };
};